module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"labelMinimum":"Prix minimum","labelMaximum":"Prix maximum"},"en":{"labelMinimum":"Minimum price","labelMaximum":"Maximum price"}}')
  delete Component.options._Ctor
}
